import React, { useState } from 'react';

const UNIT_COST = { 50: 1000, 100: 900, 300: 800, 500: 600 };
const MULT = { elec: 0.5, dig: 1.5 };

function fmt(n) {
  return n.toLocaleString('es-AR', { maximumFractionDigits: 0 });
}

function BtnGroup({ options, value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {options.map(opt => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          style={{
            padding: '9px 18px',
            borderRadius: 8,
            border: `1.5px solid ${value === opt.value ? '#0D3D2B' : '#BFD9CE'}`,
            background: value === opt.value ? '#0D3D2B' : '#E8F3EE',
            color: value === opt.value ? '#FFFFFF' : '#0D2B1E',
            fontFamily: 'inherit',
            fontSize: 14,
            fontWeight: value === opt.value ? 500 : 400,
            cursor: 'pointer',
            transition: 'all 0.15s',
            whiteSpace: 'nowrap',
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default function Pricing() {
  const [empleados,  setEmpleados]  = useState(100);
  const [empleador,  setEmpleador]  = useState('elec');
  const [empleado,   setEmpleado]   = useState('elec');
  const [gestion,    setGestion]    = useState('autonoma');

  const unitCost       = UNIT_COST[empleados];
  const firmaMultipler = MULT[empleador] + MULT[empleado];
  const firmaTotal     = firmaMultipler * empleados * unitCost;
  const gestionTotal   = gestion === 'soporte' ? empleados * unitCost : 0;
  const total          = firmaTotal + gestionTotal;

  const inputStyle = {
    background: '#FFFFFF',
    border: '1px solid #BFD9CE',
    borderRadius: 12,
    padding: '20px 22px',
    marginBottom: 0,
  };

  const labelStyle = {
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#4D7A63',
    marginBottom: 14,
    display: 'block',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F0F7F4', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 680, margin: '0 auto', padding: '48px 16px 60px' }}>

        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#0D3D2B', letterSpacing: '-0.5px', marginBottom: 6 }}>
            recibido<span style={{ color: '#1A8C5B' }}>.</span>
          </div>
          <p style={{ fontSize: 14, color: '#4D7A63', margin: 0 }}>
            Calculá el costo mensual estimado según tu configuración
          </p>
        </div>

        {/* Selectors */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 28 }}>

          <div style={inputStyle}>
            <span style={labelStyle}>Cantidad de empleados</span>
            <BtnGroup
              value={empleados}
              onChange={setEmpleados}
              options={[
                { value: 50,  label: 'Hasta 50' },
                { value: 100, label: 'Hasta 100' },
                { value: 300, label: 'Hasta 300' },
                { value: 500, label: 'Más de 300' },
              ]}
            />
          </div>

          <div style={inputStyle}>
            <span style={labelStyle}>Firma Empleador</span>
            <BtnGroup
              value={empleador}
              onChange={setEmpleador}
              options={[
                { value: 'elec', label: 'Electrónica' },
                { value: 'dig',  label: 'Digital' },
              ]}
            />
          </div>

          <div style={inputStyle}>
            <span style={labelStyle}>Firma Empleado</span>
            <BtnGroup
              value={empleado}
              onChange={setEmpleado}
              options={[
                { value: 'elec', label: 'Electrónica' },
                { value: 'dig',  label: 'Digital' },
              ]}
            />
          </div>

          <div style={inputStyle}>
            <span style={labelStyle}>Gestión</span>
            <BtnGroup
              value={gestion}
              onChange={setGestion}
              options={[
                { value: 'autonoma', label: 'Autónoma' },
                { value: 'soporte',  label: 'Con soporte' },
              ]}
            />
          </div>
        </div>

        {/* Result panel */}
        <div style={{
          background: '#0D3D2B',
          borderRadius: 16,
          padding: '28px 28px 24px',
          color: '#FFFFFF',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.6 }}>
              Total mensual estimado
            </span>
            <span style={{ fontSize: 12, opacity: 0.5, fontWeight: 300 }}>
              {empleados === 500 ? '500 empleados (ref.)' : `${empleados} empleados`}
            </span>
          </div>

          <div style={{ fontSize: 44, fontWeight: 700, letterSpacing: '-1.5px', lineHeight: 1, marginBottom: 4, fontVariantNumeric: 'tabular-nums' }}>
            <span style={{ fontSize: 22, fontWeight: 400, opacity: 0.6, marginRight: 4 }}>$</span>
            {fmt(total)}
          </div>

          {empleados === 500 && (
            <p style={{ fontSize: 12, opacity: 0.5, margin: '0 0 16px' }}>
              Precio indicativo para 500 empleados. Para cotizaciones mayores, consultar.
            </p>
          )}

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: 18, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {[
              { label: 'Módulo firma',  value: firmaTotal },
              { label: 'Gestión',       value: gestionTotal, zero: true },
            ].map(row => (
              <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <span style={{ opacity: 0.65 }}>{row.label}</span>
                <span style={{ fontWeight: 600, opacity: 0.9, fontVariantNumeric: 'tabular-nums' }}>
                  {row.zero && row.value === 0 ? '—' : `$ ${fmt(row.value)}`}
                </span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, marginTop: 4, paddingTop: 10, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
              <span style={{ opacity: 0.85, fontWeight: 500 }}>Total</span>
              <span style={{ fontWeight: 600, color: '#6EDCB0', fontVariantNumeric: 'tabular-nums' }}>$ {fmt(total)}</span>
            </div>
          </div>
        </div>

        <p style={{ marginTop: 18, fontSize: 11, color: '#4D7A63', textAlign: 'center', lineHeight: 1.5 }}>
          Precios en pesos argentinos (ARS) · Valores sin IVA · Sujeto a actualización
        </p>
      </div>
    </div>
  );
}
